import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';

export const nutritionRolesGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	if (!authService.hasUserRole() && !authService.hasStudentRole() && !authService.hasDemoRole()) {
		authService.navigateAfterLogin();
		return false;
	}
	return true;
};
